import { BasicShapeType } from 'widgets/BasicShapeWidget/BasicShapeWidget.types';

interface CheckIsActiveProps {
  key: string;
  formerType: BasicShapeType;
  type: BasicShapeType;
  widthPx: number;
  heightPx: number;
  cornerRadius?: number | undefined;
}

/**
 * Check if the shape swap dropdown menu item is Active
 *
 * @param label the label text of BASIC_SHAPE_WIDGET_ITEMS
 * @param formerType original type of the selected shape widget
 * @param type new type of the swapping shape widget
 * @param widthPx width of the shape widget
 * @param heightPx height of the shape widget
 * @param cornerRadius corner radius of the shape widget
 * @returns
 */
export const checkIsActive = ({
  key,
  formerType,
  type,
  widthPx,
  heightPx,
  cornerRadius,
}: CheckIsActiveProps): boolean => {
  switch (key) {
    case 'vg-icon-rounded-square':
      if (formerType === BasicShapeType.Rectangle && widthPx === heightPx) return true;
      break;
    case 'vg-icon-rounded-rectangle':
      if (formerType === BasicShapeType.Rectangle && widthPx !== heightPx && cornerRadius !== 50) return true;
      break;
    case 'vg-icon-pill':
      if (formerType === BasicShapeType.Rectangle && cornerRadius === 50) return true;
      break;
    case 'vg-icon-circle':
      if (formerType === BasicShapeType.Ellipse && widthPx === heightPx) return true;
      break;
    case 'vg-icon-oval':
      if (formerType === BasicShapeType.Ellipse && widthPx !== heightPx) return true;
      break;
    default:
      return formerType === type;
  }

  return false;
};
